import { DropMode } from '@constants';

export const useDropMode = () => {
  const doubleWarehouseDMs = [DropMode.SLD, DropMode.SDT, DropMode.SPLO];

  return { doubleWarehouseDMs };
};
